<kor-page scrollable>
  <kor-app-bar
    slot="top"
    logo="https://kor-ui.com/assets/favicon.png"
    label="Kor Theme Editor"
  ></kor-app-bar>
  <router-outlet></router-outlet>
</kor-page>